module.exports = __webpack_public_path__ + "img/doctor-solo.6ce97ec0.png";